import React, { useState } from 'react'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import { Flex } from 'ui/acro'
import { Button, H3 } from 'ui/bend'

const Container = styled(Flex)({
  flexDirection: 'column',
  padding: '0 16px 32px 16px'
})
const ModalTitle = styled(Text)({
  marginTop: '16px',
  marginBottom: '8px',
  fontSize: '16px',
  fontWeight: 400,
  color: '#000',
  fontFamily: 'Proxima-nova',
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const Title = styled(H3)({
  marginTop: '6px',
  marginBottom: '8px',
  fontSize: '21px',
  fontWeight: 600,
  color: '#000',
  fontFamily: 'Proxima-nova',
  lineHeight: '111%',
  '@media (min-width: 768px)': {
    marginTop: '32px'
  }
})

const Description = styled(Text)({
  marginTop: '6px',
  marginBottom: '8px',
  fontSize: '16px',
  fontWeight: 400,
  color: '#3b3b3b',
  fontFamily: 'Proxima-nova',
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const ActionButtons = styled(Flex)({
  flexDirection: 'column',
  gap: '16px',
  '@media (min-width: 768px)': {
    width: '50%',
    margin: '0 auto',
    marginTop: '32px'
  }
})

const StopButton = styled(Button)({})
const CancelButton = styled(Button)({
  background: '#fff',
  color: '#000'
})

const StopProgramModalContent = ({
  onSubmit,
  onCancel,
  isDeskTop = false,
  isSubmitting
}) => {
  return (
    <Container>
      {isDeskTop && <ModalTitle>Stop Program</ModalTitle>}
      <Title>Are you sure you want to stop this program?</Title>
      <Description>
        Any classes you have completed with this program will display on the
        Completed tab in My Practice, but the program progress will be reset.{' '}
      </Description>
      <ActionButtons>
        <StopButton onClick={onSubmit} processing={isSubmitting}>
          Stop Program
        </StopButton>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
      </ActionButtons>
    </Container>
  )
}

export default StopProgramModalContent
